import react from 'react'
import Text from '../../components/common/Text'
import Breadcrumb from '../../components/common/Breadcrumb'
import { mobile, tablet, useScreen } from '../../utils/responsive-helper'
import styled from '@emotion/styled'
import ProfileCard from '../../components/ProfileCard'
import WellBeingCard from '../../components/WellBeingCard'
import icon from '../../assets/images/icons-train-green-48-px.svg'

const FlexRow = styled.div`
  display: flex;
  ${tablet} {
    flex-direction: column-reverse;
  }
`

const BreadcrumbContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`

const TitleContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 24px;
`

const WellBeingContainer = styled.div<{ isMobile: boolean }>`
  /* border: 1px solid #000000; */
  margin-left: 0px;
  display: grid;
  grid-template-columns: repeat(auto-fill, 267px);
  grid-gap: 24px;
  justify-content: ${(isMobile) => (isMobile ? 'center' : 'flex-start')};
  margin-bottom: 15px;
`

const EClaim = () => {
  const { isMobile } = useScreen()

  return (
    <div>
      <BreadcrumbContainer>
        <Breadcrumb />
      </BreadcrumbContainer>
      <FlexRow>
        <ProfileCard size="medium" />
      </FlexRow>
      <TitleContainer>
        <Text type="Bold" size={32}>สวัสดิการเพิ่มเติมทั้งหมด</Text>
      </TitleContainer>
      <WellBeingContainer isMobile={isMobile}>
        <WellBeingCard
          title="เบิกค่ารถไฟฟ้า"
          icon={icon}
          onClick={() => console.log('hello world!!')}
        />

        <WellBeingCard
          title="เบิกค่ารถไฟฟ้า"
          icon={icon}
          onClick={() => console.log('hello world!!')}
        />

        <WellBeingCard
          title="เบิกค่ารถไฟฟ้า"
          icon={icon}
          onClick={() => console.log('hello world!!')}
        />

        <WellBeingCard
          title="เบิกค่ารถไฟฟ้า"
          icon={icon}
          onClick={() => console.log('hello world!!')}
        />

        <WellBeingCard
          title="เบิกค่ารถไฟฟ้า"
          icon={icon}
          onClick={() => console.log('hello world!!')}
        />

        <WellBeingCard
          title="เบิกค่ารถไฟฟ้า"
          icon={icon}
          onClick={() => console.log('hello world!!')}
        />

        <WellBeingCard
          title="เบิกค่ารถไฟฟ้า"
          icon={icon}
          onClick={() => console.log('hello world!!')}
        />

        <WellBeingCard
          title="เบิกค่ารถไฟฟ้า"
          icon={icon}
          onClick={() => console.log('hello world!!')}
        />

        <WellBeingCard
          title="เบิกค่ารถไฟฟ้า"
          icon={icon}
          onClick={() => console.log('hello world!!')}
        />
      </WellBeingContainer>
    </div>
  )
}

export default EClaim